import React from 'react';
import { CheckCircle } from 'lucide-react';
import HeaderComponent from '../components/HeaderComponent';
import FooterComponent from '../components/FooterComponent';
import '../components/css/Pricing.css';

const Pricing = () => {
  return (
    <div className="pricing-page">
      
      {/* --- HERO SECTION --- */}
      <section className="pricing-header text-center  ">
        <div className="container">
          <h1 className="mb-3">Simple, Transparent Pricing</h1>
          <p className="text-muted fs-5">Choose the plan that works best for you. No hidden fees, cancel anytime.</p>
        </div>
      </section>

      {/* --- PRICING CARDS SECTION --- */}
      <section className="pricing-card">
        <div className="container">
          <div className="row g-4 align-items-center">
            
            {/* 1. FREE PLAN */}
            <div className="col-lg-4 col-md-4">
              <div className="price-card">
                <h3>Free</h3>
                <div className="mb-2">
                    <span className="price-value">$0</span>
                    <span className="price-month">/month</span>
                </div>
                <p className="text-muted small">Perfect for getting started</p>
                <ul className="feature-list-pricing">
                  <li><CheckCircle size={16} className="text-success" /> Browse all roles</li>
                  <li><CheckCircle size={16} className="text-success" /> Apply to up to 5 roles/month</li>
                  <li><CheckCircle size={16} className="text-success" /> Basic profile</li>
                  <li><CheckCircle size={16} className="text-success" /> Email notifications</li>
                </ul>
                <button className="btn btn-pricing-outline">Get Started</button>
              </div>
            </div>

            {/* 2. PREMIUM PLAN (Highlighted) */}
            <div className="col-lg-4 col-md-6">
              <div className="price-card premium-card shadow-lg">
                <span className="popular-badge">Popular</span>
                <h3>Premium</h3>
                <div className="mb-2">
                    <span className="price-value">$29</span>
                    <span className="price-month">/month</span>
                </div>
                <p className="text-muted small">For serious performers</p>
                <ul className="feature-list-pricing">
                  <li><CheckCircle size={16} className="text-success" /> Unlimited applications</li>
                  <li><CheckCircle size={16} className="text-success" /> AI role recommendations</li>
                  <li><CheckCircle size={16} className="text-success" /> Priority in search results</li>
                  <li><CheckCircle size={16} className="text-success" /> AI performance scoring</li>
                  <li><CheckCircle size={16} className="text-success" /> Advanced analytics</li>
                  <li><CheckCircle size={16} className="text-success" /> Verified badge on profile</li>
                </ul>
                <button className="btn btn-pricing-filled">Start Free Trial</button>
              </div>
            </div>

            {/* 3. CASTING PRO PLAN */}
            <div className="col-lg-4 col-md-6">
              <div className="price-card">
                <h3>Casting Pro</h3>
                <div className="mb-2">
                    <span className="price-value">$99</span>
                    <span className="price-month">/month</span>
                </div>
                <p className="text-muted small">For casting professionals</p>
                <ul className="feature-list-pricing">
                  <li><CheckCircle size={16} className="text-success" /> Post unlimited roles</li>
                  <li><CheckCircle size={16} className="text-success" /> AI talent matching</li>
                  <li><CheckCircle size={16} className="text-success" /> Unlimited audition scheduling</li>
                  <li><CheckCircle size={16} className="text-success" /> Advanced applicant filters</li>
                  <li><CheckCircle size={16} className="text-success" /> Team collaboration tools</li>
                  <li><CheckCircle size={16} className="text-success" /> Priority support</li>
                </ul>
                <button className="btn btn-pricing-outline">Get Started</button>
              </div>
            </div>

          </div>

          {/* --- ENTERPRISE SECTION --- */}
          <div className="enterprise-box text-center shadow-sm">
             <h3 className="fw-bold text-dark mb-3">Enterprise Solutions</h3>
             <p className="text-muted mb-4 mx-auto" style={{maxWidth: '600px'}}>
                For large production houses, agencies, and organizations with custom needs. Contact us for volume pricing and dedicated support.
             </p>
             <button className="btn btn-pricing-filled" style={{width: 'auto', padding: '12px 40px'}}>Contact Sales</button>
          </div>

          {/* --- FAQ SECTION --- */}
          <div className="faq-section ">
             <h2 className="text-center fw-bold ">Frequently Asked Questions</h2>
             <div className="row justify-content-center">
               
                      <div className="col-lg-8 desktop-faq">

                   
                   <div className="faq-item shadow-sm">
                      <h5>Can I cancel my subscription anytime?</h5>
                      <p>Yes, you can cancel your subscription at any time. Your access will continue until the end of your billing period.</p>
                   </div>
                   </div>

                    <div className="col-lg-8 desktop-faq">
                   <div className="faq-item shadow-sm">
                      <h5>Is there a free trial?</h5>
                      <p>Yes, Premium plans come with a 7-day free trial. No credit card required to start.</p>
                   </div>

                   <div className="faq-item shadow-sm">
                      <h5>What payment methods do you accept?</h5>
                      <p>We accept all major credit cards, debit cards, and digital payment methods through our secure payment partners.</p>
                   </div>

                   <div className="faq-item shadow-sm">
                      <h5>Do casting professionals pay per role posting?</h5>
                      <p>No, with the Casting Pro subscription, you can post unlimited roles. Pay-per-post options are available for individual listings.</p>
                   </div>

                </div>
             </div>
          </div>

          {/* <div className="faq-section">
  <h2 className="text-center fw-bold">Frequently Asked Questions</h2>

  <div className="faq-scroll-wrapper">
    <div className="row justify-content-center faq-row">

      <div className="col-lg-12 desktop-faq col-12">
        <div className="faq-item shadow-sm">
          <h5>Can I cancel my subscription anytime?</h5>
                      <p>Yes, you can cancel your subscription at any time. Your access will continue until the end of your billing period.</p>
        </div>
      </div>

      <div className="col-lg-12 col-md-6 col-12">
        <div className="faq-item shadow-sm">
          <h5>Is there a free trial?</h5>
                      <p>Yes, Premium plans come with a 7-day free trial. No credit card required to start.</p>
        </div>
      </div>

      <div className="col-lg-12 col-md-8 col-12">
        <div className="faq-item shadow-sm">
          <h5>What payment methods do you accept?</h5>
                      <p>We accept all major credit cards, debit cards, and digital payment methods through our secure payment partners.</p>
        </div>
      </div>

<div className="col-lg-12 col-md-4 col-12">  
        <div className="faq-item shadow-sm">
          <h5>Do casting professionals pay per role posting?</h5>
                      <p>No, with the Casting Pro subscription, you can post unlimited roles. Pay-per-post options are available for individual listings.</p>
        </div>
      </div>

    </div>
  </div>
</div> */}

        </div>
      </section>
       

     
     <section className="faq-section mobile-faq">
  <div className="row g-3">

    <div className="col-6">
      <div className="faq-item shadow-sm">
        <h5>Can I cancel my subscription anytime?</h5>
        <p>Yes, you can cancel your subscription at any time. Your access will continue until the end of your billing period.</p>
      </div>
    </div>

    <div className="col-6">
      <div className="faq-item shadow-sm">
        <h5>Is there a free trial?</h5>
        <p>Yes, Premium plans come with a 7-day free trial. No credit card required to start.</p>
      </div>
    </div>

    <div className="col-6">
      <div className="faq-item shadow-sm">
        <h5>What payment methods do you accept?</h5>
        <p>We accept all major credit cards, debit cards, and digital payment methods through our secure payment partners.</p>
      </div>
    </div>

    <div className="col-6">
      <div className="faq-item shadow-sm">
        <h5>Do casting professionals pay per role posting?</h5>
        <p>No, with the Casting Pro subscription, you can post unlimited roles. Pay-per-post options are available for individual listings.</p>
      </div>
    </div>

  </div>
</section>

      {/* <FooterComponent /> */}
    </div>
  );
};

export default Pricing;